import type { ButtonProps } from 'antd';
import { Button as AntdButton } from 'antd';
import cn from 'classnames';
import type { FC, PropsWithChildren } from 'react';

export const Button: FC<PropsWithChildren<ButtonProps>> = ({
    children,
    disabled = false,
    className = '',
    ...props
}) => {
    return (
        <AntdButton
            className={cn(
                'mi',
                {
                    'opacity-50 cursor-not-allowed': disabled,
                },
                className,
            )}
            disabled={disabled}
            {...props}
        >
            {children}
        </AntdButton>
    );
};
